module.exports = "/build/web/svg/dropdown-plus.033ad58e2d5b5814d2a4960d69c15970.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/dropdown-plus.svg
// module id = 104
// module chunks = 24